import { makeStyles } from '@material-ui/core'
import { createMuiTheme } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: theme.typography.fontWeightRegular,
  },
  parentDetails: {
    padding: 0,
  },
  list: {
    width: '100%',
  },
  listItemText: {
    paddingLeft: '.8rem',
    fontSize: '18px',
  },
}))

// Material UI Theme
export const theme = createMuiTheme({
  overrides: {
    MuiAccordion: {
      root: {
        width: '100%',
        "&$expanded": {
          background: '#F7F7F7',
        },
        "&$rounded": {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        },
      },
      rounded: {
        "&:first-child": {
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        },
        "&:last-child": {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        },
      }
    },
    MuiTypography: {
      body1: {
        fontSize: '16px',
      },
    },
    MuiList: {
      padding: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
    MuiListItemText: {
      root: {
        marginTop: 0,
        marginBottom: 0,
      },
    },
  }
})